import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import es from './locales/es.json';
import en from './locales/en.json';
import pt from './locales/pt.json';

//
// Names are endonyms -- a language is always listed in its own language, not
// translated into the current UI language, so these live here rather than in the
// locale files. Flags match the og:locale of each language (es_PY, en_US, pt_BR).
//
export const SUPPORTED_LANGUAGES = [
  { code: 'es', name: 'Español', flag: '🇵🇾' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'pt', name: 'Português', flag: '🇧🇷' },
];

export const languageOptionLabel = ({ name, flag }) => `${name} ${flag}`;

//
// Amounts stay in Paraguayan guaraní formatting (dot thousands separators) in
// every language: the figures are PYG and the input mask depends on dots.
//
export const AMOUNT_LOCALE = 'es-PY';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
      pt: { translation: pt },
    },
    fallbackLng: 'es',
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    load: 'languageOnly', // es-PY -> es, pt-BR -> pt, en-US -> en
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
      caches: ['localStorage'],
    },
  });

export default i18n;
